registerLocaleData(en);
import { BrowserModule } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { Angulartics2Module } from 'angulartics2';
import { NgxStripeModule } from 'ngx-stripe';
import { NgxImageCompressService } from 'ngx-image-compress';
import { CookieService } from 'ngx-cookie-service';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NZ_I18N, en_US } from 'ng-zorro-antd/i18n';

import en from '@angular/common/locales/en';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { APIService } from './services/api/api-service';
import { AuthGuard } from './auth/guards/auth.guard';
import { LoginGuard } from './auth/guards/login.guard';

import { environment } from '../environments/environment';
import { AuthService } from './auth/auth-client.service';
import { UserService } from './services/api/user.service-client';
import { BrandService } from './services/brand.service';
import { reducers, effects } from './+store/app.states';
import { JwtInterceptor } from './auth/jwt.interceptor';
import { AppFacade } from './+store/app/app.facade';
import { CheckoutFacade } from './+store/checkout/checkout.facade';
import { ConsultationFacade } from './+store/consultation/consultation.facade';
import { AccountFacade } from './+store/account/account.facade';
import { AuthFacade } from './auth/+store/auth.facade';
import { OrdersFacade } from './+store/orders/orders.facade';
import { ProductsFacade } from './+store/products/products.facade';
import { InboxFacade } from './+store/inbox/inbox.facade';
import { AppointmentFacade } from './+store/appointment/appointment.facade';
import { NotificationFacade } from './+store/notification/notification.facade';
import { LabReqFacade } from './+store/lab-req/lab-req.facade';
import { ChatService } from './+store/chat/chat.service';
import {
  NbDatepickerModule,
  NbLayoutModule,
  NbSpinnerModule,
  NbThemeModule
} from '@nebular/theme';
import { PresenceService } from './services/presence.service';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { CheckoutFacadeV2 } from './+store/checkout-v2/checkout.facade';
import { SubscriptionsFacade } from './+store/subscriptions/subscriptions.facade';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NzNotificationModule,
    NzMessageModule,
    NzModalModule,
    NbThemeModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbLayoutModule,
    NbSpinnerModule,
    HttpClientModule,
    StoreModule.forRoot(reducers, {
      // metaReducers: !environment.production ? [] : [],
      runtimeChecks: {
        strictActionImmutability: true,
        strictStateImmutability: true
      }
    }),
    EffectsModule.forRoot(effects),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    Angulartics2Module.forRoot(),
    NgxStripeModule.forRoot()
  ],
  providers: [
    AuthService,
    UserService,
    NgxImageCompressService,
    CookieService,
    BrandService,
    { provide: NZ_I18N, useValue: en_US },
    AuthGuard,
    LoginGuard,
    AuthFacade,
    CheckoutFacade,
    CheckoutFacadeV2,
    SubscriptionsFacade,
    ConsultationFacade,
    InboxFacade,
    AccountFacade,
    OrdersFacade,
    ProductsFacade,
    AppointmentFacade,
    NotificationFacade,
    LabReqFacade,
    AppFacade,
    ChatService,
    PresenceService,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
